import { FileDiff, Undo2 } from "lucide-react";
import { fmtDate } from "../proposal/format";

// Why the client is back on the form: Medicys issued an amended
// version, or set their signature aside and asked for a change.
export function AmendmentNotice({ amendment, returned }) {
  if (amendment) {
    const sup = amendment.supersedes || {};
    return (
      <div className="rounded-xl border border-[#1B4F8A]/30 bg-[#EAF3FA] p-5 sm:p-6 flex gap-4" data-testid="commission-amendment-notice" data-version={amendment.version}>
        <span className="w-11 h-11 rounded-full bg-[#1B4F8A] text-white flex items-center justify-center shrink-0"><FileDiff className="w-5 h-5" /></span>
        <div className="flex flex-col gap-2 text-[15px] text-stone-800 leading-relaxed min-w-0">
          <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#1B4F8A]">Version {amendment.version} · Amended Statement of Work</p>
          <p>
            <span className="font-semibold">Medicys has issued version {amendment.version} of your Statement of Work</span>
            {amendment.issued_by_name ? <> ({amendment.issued_by_name}, {fmtDate(amendment.issued_at)})</> : null}.
            {sup.signed_at ? <> It replaces the version signed by {sup.signed_by} on {fmtDate(sup.signed_at)}, which stays in force until this one is signed by both parties.</> : null}
          </p>
          {amendment.summary && (
            <blockquote className="border-l-2 border-[#1B4F8A]/40 pl-4 text-stone-700 whitespace-pre-line" data-testid="commission-amendment-summary">{amendment.summary}</blockquote>
          )}
          <p className="text-sm text-stone-600">Your previous answers are filled in below. Please check them, review the new document, which lists the changes on its first page, and sign.</p>
        </div>
      </div>
    );
  }
  if (returned) {
    return (
      <div className="rounded-xl border border-amber-300 bg-amber-50 p-5 sm:p-6 flex gap-4" data-testid="commission-returned-notice">
        <span className="w-11 h-11 rounded-full bg-amber-500 text-white flex items-center justify-center shrink-0"><Undo2 className="w-5 h-5" /></span>
        <div className="flex flex-col gap-2 text-[15px] text-amber-950 leading-relaxed min-w-0">
          <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-amber-800">A change is needed before Medicys countersigns</p>
          <p>
            Thank you for signing{returned.signed_at ? ` on ${fmtDate(returned.signed_at)}` : ""}. Before countersigning, {returned.by_name || "Medicys"} asked for one change
            {returned.at ? ` (${fmtDate(returned.at)})` : ""}:
          </p>
          <blockquote className="border-l-2 border-amber-400 pl-4 text-amber-900 whitespace-pre-line" data-testid="commission-returned-reason">{returned.reason}</blockquote>
          <p className="text-sm text-amber-900/80">Your earlier signature has been set aside. Please make the change below, review the document and sign again.</p>
        </div>
      </div>
    );
  }
  return null;
}
